export default __webpack_public_path__ + "static/media/services4.d05d632d.png";